
import { createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, IncludeBearerTokenCondition, provideKeycloak } from 'keycloak-angular';

import { environment } from '../../environments/environment';

const urlPatternEscaped = `^(${environment.api.backoffice}|${environment.api.consumer}|${environment.api.user})(/.*)?$`.replaceAll('/', '\\/');

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`${urlPatternEscaped}`, 'i'),
  bearerPrefix: 'Bearer'
});

export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      url: environment.keycloak.url,
      realm: environment.keycloak.realm,
      clientId: environment.keycloak.clientId
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/console/silent-check-sso.html',
      enableLogging: true
    },
    providers: [{
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition]
    }],
  });
